<template>
  <div id="error">
    <main v-if="isDC">
      本システムはお使いのブラウザではご利用できません。<br>
      お手数ですが、Chrome、Safari、Edgeのいずれかの最新バージョンをお使いください。
    </main>
    <main v-else>
      本システムはお使いのブラウザではご利用できません。<br>
      お手数ですが、Chromeの最新バージョンをお使いください。<br><br>
      Chromeは<a href="https://www.google.com/chrome/" target="_blank">こちら</a>からダウンロードいただけます。
    </main>
  </div>
</template>
<script>
export const PTN_DC = new RegExp('^.*mmstyle.*')

export default {
  name: 'Unsupported',
  components: {
  },
  data () {
    return {
      isDC: PTN_DC.test(location.href)
    }
  },
  methods: {
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>
#error {
  height: calc(100% - 140px);
  text-align: center;
  margin-top: 100px;
}
main {
  height: 100%;
  color: #ff4500;
  font-weight: bold;
  line-height: 40px;
  a{
    text-decoration: underline;
  }
  a:hover {
    color: #000;
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/UnSupported.vue